import React from 'react';
import ReactDOM from 'react-dom'
import './index.css';

import QRCODE from "./QRCODE/QRCODE";


ReactDOM.render(<QRCODE />, document.getElementById('ma9_qrcode_generator'))